import axios from "axios";
import authHeader from "services/auth-header";
import drIdsHashed from "services/dr-ids-hashed";

const docParam = drIdsHashed();

class SmsReminderService {
  createSmsReminder(parameters) {
    var dataParams = parameters;
    dataParams.eb_doctor_id = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "dr/doctor_sms_reminders",
        dataParams,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  listSmsReminders(parameters) {
    var dataParams = parameters;
    dataParams.eb_doctor_id = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + "dr/doctor_sms_reminders", {
        headers: authHeader(),
        params: dataParams,
      })
      .then((response) => {
        return response.data;
      });
  }

  updateSmsReminder(id, parameters) {
    var dataParams = parameters;
    dataParams.eb_doctor_id = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .put(
        process.env.REACT_APP_API_ENDPOINT + "dr/doctor_sms_reminders/" + id,
        dataParams,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  deleteSmsReminder(id, parameters) {
    var dataParams = parameters;
    dataParams.eb_doctor_id = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .delete(
        process.env.REACT_APP_API_ENDPOINT + "dr/doctor_sms_reminders/" + id,
        {
          headers: authHeader(),
          params: dataParams,
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getSmsReminderLogs(parameters) {
    var dataParams = parameters;
    dataParams.eb_doctor_id = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT + "dr/doctor_sms_reminders/logs",
        {
          headers: authHeader(),
          params: dataParams,
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  getSmsReminderAllocation(parameters) {
    var dataParams = parameters;
    dataParams.eb_doctor_id = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          "dr/doctor_sms_reminders/allocation",
        {
          headers: authHeader(),
          params: dataParams,
        }
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new SmsReminderService();
